import { useQuery } from "@tanstack/react-query";
import axios from "../../axios";

const normalizeInstitute = (data) => {
  const result = data?.result || data?.data || data || null;
  return result?.institute || result;
};

export const getUserInstituteId = (user) => {
  for (const institute of [user?.instituteId, user?.libraryId]) {
    const id = typeof institute === "object" && institute !== null
      ? institute.instituteId || institute._id || institute.id
      : institute;
    if (typeof id === "string" && id.trim()) return id.trim();
  }
  return "";
};

export const getInstituteName = (institute) =>
  institute?.name ||
  institute?.instituteName ||
  institute?.assignedInstituteName ||
  institute?.title ||
  "";

export const getInstituteLogo = (institute) =>
  institute?.logo ||
  institute?.instituteLogo ||
  institute?.libraryLogo ||
  institute?.logoUrl ||
  institute?.image ||
  institute?.appLogo ||
  "";

export const useInstitute = (instituteId) => {
  const resolvedInstituteId =
    typeof instituteId === "string" ? instituteId.trim() : "";

  return useQuery({
    queryKey: ["institute", resolvedInstituteId],
    queryFn: async () => {
      const { data } = await axios.get(`/institute/${encodeURIComponent(resolvedInstituteId)}`);
      return normalizeInstitute(data);
    },
    enabled: Boolean(resolvedInstituteId),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};
